import * as $runtime from "../runtime.js";
import * as Control$dMonad$dMaybe$dTrans from "../Control.Monad.Maybe.Trans/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Effect from "../Effect/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
const identity = x => x;
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const weaken = x => Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(x);
const unWeakDynamic = v => v;
const tagWeakDyn = wdyn => event => Specular$dFRP$dBase.filterMapEvent(identity)(Specular$dFRP$dBase.attachDynWith(a => _b => a)(wdyn)(event));
const switchWeakDyn = v => Specular$dFRP$dBase.switch(Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Nothing") { return Specular$dFRP$dBase.never; }
  if (v2.tag === "Just") { return v2._1; }
  $runtime.fail();
})(v));
const subscribeWeakDyn_ = dictMonadFRP => {
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
  return handler => v => subscribeDyn_(traverse_(handler))(v);
};
const monadWeakDynamic = {
  Applicative0: () => Control$dMonad$dMaybe$dTrans.applicativeMaybeT(Specular$dFRP$dBase.monadDynamic),
  Bind1: () => Control$dMonad$dMaybe$dTrans.bindMaybeT(Specular$dFRP$dBase.monadDynamic)
};
const mkWeakDynamic = x => x;
const uniqWeakDynBy = dictMonadFRP => {
  const map3 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map;
  const uniqDynBy = Specular$dFRP$dBase.uniqDynBy(dictMonadFRP);
  return eq => wdyn => map3(mkWeakDynamic)(uniqDynBy(v => v1 => {
    if (v.tag === "Just") {
      if (v1.tag === "Just") { return eq(v._1)(v1._1); }
      return false;
    }
    if (v.tag === "Nothing") { return v1.tag === "Nothing"; }
    return false;
  })(wdyn));
};
const holdWeakDyn = dictMonadFRP => {
  const map3 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map;
  const holdDyn = Specular$dFRP$dBase.foldDyn(dictMonadFRP)(x => v => x);
  return change => map3(x => x)(holdDyn(Data$dMaybe.Nothing)(Specular$dFRP$dBase.functorEvent.map(Data$dMaybe.Just)(change)));
};
const subscribeWeakDyn = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const Bind1 = Monad0.Bind1();
  const newEvent = Specular$dFRP$dBase.newEvent(dictMonadFRP.MonadEffect0());
  const holdWeakDyn1 = holdWeakDyn(dictMonadFRP);
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
  const pure1 = Monad0.Applicative0().pure;
  return handler => wdyn => Bind1.bind(newEvent)(v => Bind1.bind(holdWeakDyn1(v.event))(result => Bind1.bind(subscribeDyn_(traverse_(a => {
    const $0 = handler(a);
    return () => {
      const $1 = $0();
      return v.fire($1)();
    };
  }))(wdyn))(() => pure1(result))));
};
const functorWeakDynamic = {map: f => v => Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.functorMaybe.map(f))(v)};
const changedW = x => Specular$dFRP$dBase.filterMapEvent(identity)(x);
const bindWeakDynamic = /* #__PURE__ */ Control$dMonad$dMaybe$dTrans.bindMaybeT(Specular$dFRP$dBase.monadDynamic);
const attachWeakDynWith = f => wdyn => event => Specular$dFRP$dBase.filterMapEvent(identity)(Specular$dFRP$dBase.attachDynWith(a => b => Data$dMaybe.applyMaybe.apply(a.tag === "Just"
  ? Data$dMaybe.$Maybe("Just", f(a._1))
  : Data$dMaybe.Nothing)(Data$dMaybe.$Maybe("Just", b)))(wdyn)(event));
const applyWeakDynamic = /* #__PURE__ */ Control$dMonad$dMaybe$dTrans.applyMaybeT(Specular$dFRP$dBase.monadDynamic);
const applicativeWeakDynamic = /* #__PURE__ */ Control$dMonad$dMaybe$dTrans.applicativeMaybeT(Specular$dFRP$dBase.monadDynamic);
export {
  applicativeWeakDynamic,
  applyWeakDynamic,
  attachWeakDynWith,
  bindWeakDynamic,
  changedW,
  functorWeakDynamic,
  holdWeakDyn,
  identity,
  mkWeakDynamic,
  monadWeakDynamic,
  subscribeWeakDyn,
  subscribeWeakDyn_,
  switchWeakDyn,
  tagWeakDyn,
  traverse_,
  unWeakDynamic,
  uniqWeakDynBy,
  weaken
};
